var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLayoutGrid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H3C2.4 2 2 2.4 2 3V10C2 10.6 2.4 11 3 11H10C10.6 11 11 10.6 11 10V3C11 2.4 10.6 2 10 2ZM9 9H4V4H9V9ZM21 2H14C13.4 2 13 2.4 13 3V10C13 10.6 13.4 11 14 11H21C21.6 11 22 10.6 22 10V3C22 2.4 21.6 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.4 13 13 13.4 13 14V21C13 21.6 13.4 22 14 22H21C21.6 22 22 21.6 22 21V14C22 13.4 21.6 13 21 13ZM20 20H15V15H20V20ZM10 13H3C2.4 13 2 13.4 2 14V21C2 21.6 2.4 22 3 22H10C10.6 22 11 21.6 11 21V14C11 13.4 10.6 13 10 13ZM9 20H4V15H9V20Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLayoutGrid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconLayoutGrid.0c8be0831dc753ba905c1c0e269d7844.svg";